import React from "react"
import { Col, Form, Row  } from "react-bootstrap"

interface Props {
    errorMessage?: React.ReactNode,
    label: React.ReactNode,
    // sm type can also be ColProps["sm"] if other values than these ones are needed
    sm?: number | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "11" | "12";
}

const FormRow: React.FC<Props> = ({ children, errorMessage, label, sm="9" }) => {

    return (
        <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="3">
                {label}
            </Form.Label>
            <Col sm={sm}>
                {children}
                {errorMessage && 
                    <Form.Control.Feedback type="invalid">
                        {errorMessage}
                    </Form.Control.Feedback>
                }
            </Col>
        </Form.Group>
    )
}

export default FormRow


// WEBPACK FOOTER //
// ./src/shortcuts/components/FormRow.tsx